import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_83y6fhr0: FaireBrandEntity = {
  token: "b_83y6fhr0",
  type: "brand",
  name: "Latika Beauty",
  avatarUrl:
    "https://cdn.faire.com/fastly/a776dbe1bd2eb061137394e2c689fa577373e74bf5dafbd74c1e48b941664e80.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/868aabd012ae328ddce03379f54355f574ec74b1f1e4a5a9b83ff42c4d8a41b9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a776dbe1bd2eb061137394e2c689fa577373e74bf5dafbd74c1e48b941664e80.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/868aabd012ae328ddce03379f54355f574ec74b1f1e4a5a9b83ff42c4d8a41b9.png",
  location: "Liberty Hill, TX, USA",
  minimumOrderDollars: 136,
  rating: 5,
  reviewCount: 478,
  isTopShop: true,
  isInsider: true,
  description:
    "Latika creates elevated self-care for modern life - luxurious bath bombs, shower steamers, and body care designed to bring beauty, balance, and intention into everyday rituals.\n\nOur bestsellers include hand-decorated geode bath bombs, signature bath soaks, and whipped scrubs that deliver spa-level indulgence with mess-free use and gift-worthy presentation. Latika is a proven performer in over 8,000 retail locations, including Anthropologie and Urban Outfitters.\n\nFemale-founded and family-operated since 2012, all Latika products are thoughtfully designed, handmade, and shipped from our Texas facility. We focus on clean, skin-loving ingredients, consistent performance, and refined visual storytelling that stands out on the shelf.\n\nLatika products are designed to inspire gifting, encourage reorders, and elevate your assortment with reliable sell-through.\n\nRetailers enjoy fast fulfillment, retailer-first support, and curated marketing assets to help products move confidently in-store and online.\n\nLatika is where artistry meets intention - thoughtfully made self-care your customers return for.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:01.180Z",
    importedBy: "entity-db-cli",
  },
};
